import React from "react";
import PageHeader from "../../components/PageHeader";
import TeamMemberCreateComponent from "../../components/TeamMembers/TeamMemberCreate";

class TeamMemberCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Team Member Create"
                            Breadcrumb={[
                                { name: "Team Members", navigate: "/team-members" },
                                { name: "Team Member Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <TeamMemberCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamMemberCreate;
